window.preventBrowserDownload = (isProduction) => {
    if (!isProduction) {
        return;
    }

    const element = document.querySelector('body');

    document.addEventListener("DOMContentLoaded", () => {
        element.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });

        element.addEventListener('dragstart', (event) => {
            event.preventDefault();
        });

        element.addEventListener('keydown', (event) => {
            const ctrlKey = event.ctrlKey || event.metaKey;

            if (event.shiftKey && ctrlKey && event.key === 'c') {
                event.preventDefault();
            }

            if (ctrlKey && (['p', 'j', 'u'].includes(event.key) || event.altKey)) {
                event.preventDefault();
            }
        });
    });
}

window.addEventListener('keydown', (event) => {
    if(event.key === 'F12') {
        event.preventDefault();
    }
})
